import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../api/client'

export interface Interest {
  id: number
  slug: string
  title: string
  emoji?: string
}

export interface City {
  id: number
  name: string
  slug: string
  regionName?: string
  timezone?: string
}

export function useInterests() {
  return useQuery({
    queryKey: ['interests'],
    queryFn: () => apiClient.get<Interest[]>('/api/reference/interests'),
    staleTime: 1000 * 60 * 5,
  })
}

export function useCities(query?: string) {
  return useQuery({
    queryKey: ['cities', query],
    queryFn: () => {
      const url = query ? `/api/reference/cities?q=${query}` : '/api/reference/cities'
      return apiClient.get<City[]>(url)
    },
    enabled: !query || query.length > 0,
    staleTime: 1000 * 60 * 5,
  })
}
